import { createContext, ReactNode, useContext } from 'react'
import { ModalRootProps } from '@iveco-ti/iveco-ds'

export type ModalActions = {
  type: ModalRootProps['type']
  title: string
  description?: string | ReactNode
  cancelText?: string
  confirmText?: string
  onCancel?: () => void
  onConfirm?: () => void | Promise<void>
  isLoading?: boolean
}

export type ModalContextProps = ModalActions & {
  handleModal: (props: Omit<ModalActions, 'handleModal'>) => void
  toggleLoading: () => void
  resetModal: () => void
}

export const ModalContext = createContext<ModalContextProps>(
  {} as ModalContextProps,
)

export const useModalProvider = () => {
  const context = useContext(ModalContext)

  if (!context) {
    throw new Error('useModalProvider must be used within a ModalProvider')
  }

  return context
}
